import { render, staticRenderFns } from "./EbEditUserPassword.vue?vue&type=template&id=c3a207da&scoped=true"
import script from "./EbEditUserPassword.vue?vue&type=script&lang=js"
export * from "./EbEditUserPassword.vue?vue&type=script&lang=js"
import style0 from "./EbEditUserPassword.vue?vue&type=style&index=0&id=c3a207da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3a207da",
  null
  
)

export default component.exports